import { useEffect, useRef, useState } from "react";
import { Button, Card, Form, Grid, Loader, Icon } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FullCalendar from "@fullcalendar/react";
import listPlugin from "@fullcalendar/list";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import "./agendaView.css";
import JobSchedulingSearch from "../Search";
import * as jobSchedulingReducer from "../jobScheduling.reducer";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const AgendaView = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [jobListData, setJobListData] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedDay, setSelectedDay] = useState(
    props.selectedDay ? props.selectedDay : new Date()
  );
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCard, setSelectedCard] = useState("");
  const calendarRef = useRef(null);
  const externalListRef = useRef(null);
  const externalEventsRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [insertJobCard, setInsertJobCard] = useState(false);
  const [draggedJobCard, setDraggedJobCard] = useState(false);

  useEffect(() => {
    if (externalEventsRef.current) {
      new Draggable(externalEventsRef.current, {
        itemSelector: ".fc-event-draggable",
        eventData: function (eventEl) {
          const cardData = JSON.parse(eventEl.dataset.event);
          return {
            title: cardData.title,
            duration: cardData.duration,
            create: true,
            id: cardData.id,
            extendedProps: cardData.extendedProps,
            color: cardData.extendedProps.color || "#007bff",
          };
        },
      });
    }
  }, []);

  useEffect(() => {
    if (props.agendaEvents) {
      setEvents(props.agendaEvents);
    }
  }, [props.agendaEvents]);

  useEffect(() => {
    if (props.unscheduledJobs) setJobListData(props.unscheduledJobs);
  }, [props.unscheduledJobs]);

  useEffect(() => {
    if (props.selectedDay) {
      setSelectedDay(props.selectedDay);
    }
  }, [props.selectedDay]);

  useEffect(() => {
    if (calendarRef.current && events.length > 0 && selectedDay) {
      console.log("test");
      const today = selectedDay; // Or use `new Date()` for actual today
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0");
      const day = today.getDate().toString().padStart(2, "0");
      const todayIsoDate = `${year}-${month}-${day}`;

      // Crucial: Add a small delay to allow FullCalendar to render the new events
      const timeoutId = setTimeout(() => {
        let targetDayContainer = document.querySelector(
          `.fc-list-day[data-date="${todayIsoDate}"]`
        );
        console.log("targetDayContainer after timeout:", targetDayContainer);

        if (targetDayContainer) {
          console.log(`Scrolling to today's day container: ${todayIsoDate}`);
          const el = document.querySelector(".fc-scroller"); // Assuming this is your main scrollable element
          if (el) {
            const targetScrollPosition =
              targetDayContainer.offsetTop - el.offsetTop;
            el.scrollTo({
              top: targetScrollPosition,
              behavior: "smooth",
            });
          }
          setIsLoading(false); // Done loading/scrolling
        } else {
          // Fallback to event scroll if day container not found
          const todayEvent = document.querySelector(
            `.fc-list-event[data-date*="${todayIsoDate}"]`
          );
          if (todayEvent) {
            console.log(`Scrolling to today's event: ${todayIsoDate}`);
            todayEvent.scrollIntoView({ behavior: "smooth", block: "start" });
            setIsLoading(false);
          } else {
            console.warn(
              "Could not find a specific header or event for today. Calendar might be empty or data not loaded for today. Scrolling to top."
            );
            const mainScroller = document.querySelector(".fc-scroller");
            if (mainScroller) {
              mainScroller.scrollTop = 0;
            }
            setIsLoading(false);
          }
        }
      }, 100); // **Adjust this delay if needed** (e.g., 50ms, 100ms, 200ms)

      // Cleanup function for useEffect: clear the timeout if component unmounts
      return () => clearTimeout(timeoutId);
    } else if (events.length === 0 && !isLoading) {
      // If events become empty after loading, might need to re-evaluate loading state
      setIsLoading(false);
    }
  }, [events, selectedDay]);

  const handleDatesSet = () => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0");
      const day = today.getDate().toString().padStart(2, "0");

      const todayIsoDate = `${year}-${month}-${day}`;

      let targetDayContainer = document.querySelector(
        `.fc-list-day[data-date="${todayIsoDate}"]`
      );

      console.log(targetDayContainer);

      if (targetDayContainer) {
        console.log(`Scrolling to today's day container: ${todayIsoDate}`);
        const el = document.querySelector(".fc-scroller");
        if (el) {
          // Calculate the target scroll position
          const targetScrollPosition =
            targetDayContainer.offsetTop - el.offsetTop;

          // Use scrollTo with smooth behavior
          el.scrollTo({
            top: targetScrollPosition,
            behavior: "smooth",
          });
        }

        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      } else {
        const todayEvent = document.querySelector(
          `.fc-list-event[data-date*="${todayIsoDate}"]`
        );
        if (todayEvent) {
          console.log(`Scrolling to today's event: ${todayIsoDate}`);
          todayEvent.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          console.warn(
            "Could not find a specific header or event for today. Calendar might be empty or data not loaded for today. Scrolling to top."
          );
          const mainScroller = document.querySelector(".fc-scroller");
          if (mainScroller) {
            mainScroller.scrollTop = 0;
          }
        }
      }
    }
  };

  const renderCustomEventContent = (arg) => {
    const eventBackgroundColor =
      arg.event.backgroundColor || arg.event.color || "#007bff";

    let startTime = "";
    let endTime = "";
    let isMultiDay = false;
    let endDateFormatted = "";

    if (arg.event.start && arg.event.extendedProps.scheduledEndDateTime) {
      const start = arg.event.start;
      const end = new Date(arg.event.extendedProps.scheduledEndDateTime + "Z");

      const formatOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // This is the key change for 24-hour format
      };
      const startTimeFormatted = start.toLocaleTimeString(
        "en-US",
        formatOptions
      );

      const formatDateDDMMYYYY = (date) => {
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      const startDateOnly = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate()
      );
      const endDateOnly = end
        ? new Date(end.getFullYear(), end.getMonth(), end.getDate())
        : null;

      isMultiDay =
        endDateOnly && startDateOnly.getTime() !== endDateOnly.getTime();

      if (isMultiDay) {
        const actualEndDate = new Date(end.getTime());
        if (
          end.getHours() === 0 &&
          end.getMinutes() === 0 &&
          end.getSeconds() === 0 &&
          end.getMilliseconds() === 0
        ) {
          actualEndDate.setDate(actualEndDate.getDate() - 1);
        }
        endDateFormatted = formatDateDDMMYYYY(actualEndDate);
      }

      if (end && end.getTime() !== start.getTime()) {
        const endTimeFormatted = end.toLocaleTimeString("en-US", formatOptions);
        startTime = startTimeFormatted;
        endTime = endTimeFormatted;
      } else {
        startTime = startTimeFormatted;
      }
    }

    return (
      <>
        {arg.event.id === "0" ? (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: 20,
              color: "#8C8C8C",
              paddingBottom: 20,
              marginLeft: -15,
            }}
          >
            <span>No scheduled jobs</span>
          </div>
        ) : (
          <Grid style={{ opacity: isLoading ? 0 : 1 }}>
            <Grid.Column width={3} style={{ paddingTop: 20 }}>
              <span style={{ fontWeight: "bolder" }}>{startTime}</span>
              {endTime && (
                <div style={{ marginTop: -5 }}>
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: "bolder",
                      color: "#AFABAB",
                    }}
                  >
                    End Time: {endTime}
                  </span>
                </div>
              )}
              {isMultiDay && endDateFormatted && (
                <div style={{ marginTop: -5 }}>
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: "bolder",
                      color: "#AFABAB",
                    }}
                  >
                    {`(${endDateFormatted})`}
                  </span>
                </div>
              )}
            </Grid.Column>
            <Grid.Column width={13} style={{ paddingLeft: 0 }}>
              <div
                style={{
                  border: `2.5px solid ${eventBackgroundColor}`,
                  borderRight: `20px solid ${eventBackgroundColor}`,
                  backgroundColor: "#fff",
                  color: "#000",
                  padding: 6,
                  borderRadius: "3px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: 13,
                  height: "100%",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (arg.event.id) {
                    window.location.href = `/jobbing/${arg.event.id}`;
                  } else {
                    console.warn(
                      "Event ID is missing, cannot navigate to jobbing page."
                    );
                  }
                }}
              >
                <Grid>
                  <Grid.Column width={11} style={{ paddingTop: 13 }}>
                    <span
                      style={{
                        marginRight: "5px",
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      #{arg.event.title}
                    </span>
                  </Grid.Column>
                  <Grid.Column
                    width={5}
                    style={{ paddingTop: 20, paddingLeft: 0 }}
                  >
                    {arg.event.extendedProps.technicianName ? (
                      <div>
                        <Icon
                          name="user"
                          style={{ color: "#66cc23", marginRight: 6 }}
                        />
                        <span
                          style={{
                            border:
                              localStorage.getItem("user") ===
                              arg.event.extendedProps.technicianEmail
                                ? "2px solid #66cc23"
                                : "none",
                            paddingLeft: 8,
                            paddingRight: 8,
                            borderRadius: 5,
                            paddingTop: 3,
                            paddingBottom: 3,
                          }}
                        >
                          {arg.event.extendedProps.technicianName}
                        </span>
                      </div>
                    ) : (
                      <div style={{ paddingLeft: 21 }}>
                        <span>Unassigned</span>
                      </div>
                    )}
                  </Grid.Column>
                </Grid>
                <div style={{ paddingTop: 15 }}>
                  <span
                    style={{
                      color:
                        arg.event.extendedProps.companyName === "Unassigned"
                          ? "#808080"
                          : "#000",
                    }}
                  >
                    {arg.event.extendedProps.companyName}
                  </span>
                  <br />
                  <span>{arg.event.extendedProps.customerLocation}</span>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        )}
      </>
    );
  };

  const renderDayHeaderContent = (arg) => {
    const dayOfWeek = arg.date.toLocaleDateString("en-US", {
      weekday: "short",
    });
    const dayOfMonth = arg.date.getDate();
    const month = arg.date.toLocaleDateString("en-US", { month: "long" });
    const year = arg.date.getFullYear();

    const formattedDate = `${dayOfWeek} ${dayOfMonth} ${month} ${year}`;

    // Get today's date without the time component for accurate comparison
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Get the argument date without the time component
    const argDate = new Date(arg.date);
    argDate.setHours(0, 0, 0, 0);

    const isToday = argDate.getTime() === today.getTime();

    return (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: 24,
          padding: "5px 10px",
          fontWeight: "bold",
          color: isToday ? "#66cc23" : "#000",
          paddingRight: 30,
          opacity: isLoading ? 0 : 1,
          backgroundColor: "#fff",
        }}
      >
        {formattedDate}
        {isToday && <span style={{ marginLeft: 10 }}>(Today)</span>}
      </div>
    );
  };
  return (
    <div className="agenda-view-container">
      <Grid columns={2} divided>
        <Grid.Column
          computer={4}
          tablet={6}
          mobile={16}
          className="job-list-section"
          style={{ paddingRight: 0 }}
        >
          <JobSchedulingSearch />
          <div className="job-list">
            <div style={{ position: "absolute", top: 300, left: 95 }}>
              {props.searchLoading ? (
                <Loader
                  active
                  className="workaround"
                  size="large"
                  inline="centered"
                >
                  Loading Job Cards...
                </Loader>
              ) : null}
            </div>
            {jobListData?.length === 0 && !props.searchLoading ? (
              <div>
                <p
                  style={{
                    textAlign: "center",
                    marginTop: 25,
                    fontSize: 20,
                  }}
                >
                  No unscheduled jobs
                </p>
              </div>
            ) : null}
            <div
              ref={externalListRef}
              className="job-list-scroll"
              disabled={props.searchLoading}
              style={{ opacity: props.searchLoading ? 0.2 : 1 }}
            >
              <div ref={externalEventsRef}>
                {insertJobCard && isDragging && (
                  <Card
                    key={draggedJobCard.id}
                    className={
                      selectedCard === draggedJobCard.jobNumber
                        ? "schedule-card"
                        : "schedule-card"
                    }
                    style={{ opacity: 0.3 }}
                  >
                    <Card.Content style={{ cursor: "pointer" }}>
                      <Grid columns={2}>
                        <Grid.Row>
                          <Grid.Column
                            width={14}
                            style={{ paddingTop: 6, paddingBottom: 6 }}
                          >
                            <b>
                              <Card.Description>
                                Job #{draggedJobCard.title}
                              </Card.Description>
                            </b>
                            <Card.Description>
                              Customer:{" "}
                              {draggedJobCard.extendedProps?.companyName ===
                              "-PLACEHOLDER-"
                                ? ""
                                : draggedJobCard.extendedProps?.companyName}
                            </Card.Description>
                            <Card.Description>
                              Address:{" "}
                              {draggedJobCard.extendedProps?.customerLocation}
                            </Card.Description>
                            <Card.Description>
                              Technician:{" "}
                              {draggedJobCard.extendedProps?.technicianName}
                            </Card.Description>
                          </Grid.Column>
                          <Grid.Column
                            width={2}
                            style={{
                              padding: 0,
                              backgroundColor: draggedJobCard.borderColor,
                            }}
                          >
                            <div className="job-state">
                              <span className="job-state-text">
                                {draggedJobCard.extendedProps?.jobStatusId === 1
                                  ? "New Request"
                                  : draggedJobCard.extendedProps
                                      ?.jobStatusId === 2
                                  ? "In Progress"
                                  : draggedJobCard.extendedProps
                                      ?.jobStatusId === 3
                                  ? "Completed"
                                  : "Invoiced"}
                              </span>
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Card.Content>
                  </Card>
                )}
                {jobListData?.map((data, i) => {
                  return (
                    <Card
                      key={data.id}
                      className={
                        selectedCard === data.jobNumber
                          ? "schedule-card active fc-event-draggable"
                          : "schedule-card fc-event-draggable"
                      }
                      data-event={JSON.stringify({
                        title: data.jobNumber,
                        duration: data.duration,
                        create: true,
                        id: data.id,
                        extendedProps: data,
                        color:
                          data.jobStatusId === 1
                            ? "#ff8f8f"
                            : data.jobStatusId === 2
                            ? "#ffdda6"
                            : data.jobStatusId === 4
                            ? "#71a8d2"
                            : data.jobStatusId === 0 || data.jobStatusId === 5
                            ? "#ced4db"
                            : "#c4f8c8",
                      })}
                    >
                      <Card.Content style={{ cursor: "pointer" }}>
                        <Grid columns={2}>
                          <Grid.Row>
                            <Grid.Column
                              width={14}
                              style={{ paddingTop: 6, paddingBottom: 6 }}
                            >
                              <b>
                                <Card.Description>
                                  Job #{data.jobNumber}
                                </Card.Description>
                              </b>
                              <Card.Description>
                                Customer:{" "}
                                {data.companyName === "-PLACEHOLDER-"
                                  ? ""
                                  : data.companyName}
                              </Card.Description>
                              <Card.Description>
                                Address: {data.customerLocation}
                              </Card.Description>
                              <Card.Description>
                                Technician: {data.technicianName}
                              </Card.Description>
                            </Grid.Column>
                            <Grid.Column
                              width={2}
                              style={{
                                padding: 0,
                                backgroundColor:
                                  data.jobStatusId === 1
                                    ? "#ff8f8f"
                                    : data.jobStatusId === 2
                                    ? "#ffdda6"
                                    : data.jobStatusId === 4
                                    ? "#71a8d2"
                                    : data.jobStatusId === 0 ||
                                      data.jobStatusId === 5
                                    ? "#ced4db"
                                    : "#c4f8c8",
                              }}
                            >
                              <div className="job-state">
                                <span className="job-state-text">
                                  {data.jobStatusId === 1
                                    ? "New Request"
                                    : data.jobStatusId === 2
                                    ? "In Progress"
                                    : data.jobStatusId === 3
                                    ? "Completed"
                                    : "Invoiced"}
                                </span>
                              </div>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Card.Content>
                    </Card>
                  );
                })}
              </div>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column
          width={12}
          style={{ paddingRight: 0, overflow: "visible", paddingRight: 23 }}
        >
          {events.length === 0 && (
            <div style={{ position: "absolute", top: 300, left: 450 }}>
              {isLoading ? (
                <Loader
                  active
                  className="workaround"
                  size="large"
                  inline="centered"
                ></Loader>
              ) : null}
            </div>
          )}
          <div style={{ flex: 3, position: "relative", paddingTop: 41 }}>
            <div style={{ position: "absolute", top: 0, left: 0, zIndex: 98 }}>
              <Button
                className="active-status"
                onClick={() => handleDatesSet()}
              >
                Today
              </Button>
            </div>
            <FullCalendar
              disabled={events.length === 0}
              ref={calendarRef}
              schedulerLicenseKey={
                process.env.REACT_APP_FULL_CALENDAR_LICENSE_KEY
              }
              height={659}
              plugins={[listPlugin, dayGridPlugin, interactionPlugin]}
              events={events}
              editable={true}
              selectable={true}
              droppable={true}
              initialView="listYear"
              initialDate={new Date()}
              headerToolbar={{
                left: false,
                center: false,
                right: false,
              }}
              scrollTime={false}
              scrollTimeReset={false}
              dayHeaderContent={renderDayHeaderContent}
              eventContent={renderCustomEventContent}
              noEventsContent=""
            />
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    scheduledJobs: state.jobScheduling.scheduledJobs,
    unscheduledJobs: state.jobScheduling.unscheduledJobs,
    agendaEvents: state.jobScheduling.agendaEvents,
    selectedDay: state.jobScheduling.selectedDay,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(jobSchedulingReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AgendaView)
);
